import _ from "lodash";
import {
  Component,
} from "react";
import store from "CommonState/store";
import {
  beforeSaveVersicherung,
  beforeSaveWeiteree,
  normalizeEditsPflege,
  schema,
  validateEditsPflege,
  validateEditsVersicherung,
} from "Apis/person-lbvstatus-api";
import {
  createInjectsSelector,
  injectsFromSchema,
} from "CommonCore/schema-util";
import SHKFormTab, {
  buildSubSchemas,
} from "App/shk-form-tab";
import {
  getModus,
} from "App/antragsteller-modus";

export const subpanels = [
  { key: "rentenr", header: "1. Rentenversicherungsnummer", endpoint: `/api/shkperson/lbvstatus` },
  {
    key: "versicherung",
    header: "2. Angaben zur Krankenversicherung",
    endpoint: `/api/shkperson/lbvstatus`,
    beforeSave: beforeSaveVersicherung,
    validateEdits: validateEditsVersicherung,
  },
  { key: "stichtag", header: "Am Stichtag 31. Dezember 2002 ...", endpoint: `/api/shkperson/lbvstatus` },
  {
    key: "pflege",
    header: "3. Pflegeversicherung",
    endpoint: `/api/shkperson/lbvstatus`,
    checkTrigger: (entity, edits) => {
      normalizeEditsPflege(entity, edits);
      return { edits };
    },
    validateEdits: validateEditsPflege,
  },
  { key: "rente", header: "4. Rentenversicherung", endpoint: `/api/shkperson/lbvstatus` },

  /*
   * { key: 'ort', header: '5. Beschäftigungsort', endpoint: `/api/shkperson/lbvstatus`, },
   * { key:'weitereb', header:'E. Weitere Beschäftigungen', endpoint: `/api/shkperson/lbvstatus`,  },
   */
  { key: "weiteree", header: "7. Weitere Einkommen", endpoint: `/api/shkperson/lbvstatus`, beforeSave: beforeSaveWeiteree },
  { key: "studium", header: "8. Studium / Praktikum", endpoint: `/api/shkperson/lbvstatus` },
  { key: "arbeitslos", header: "9. Arbeitslosigkeit", endpoint: `/api/shkperson/lbvstatus` },
  { key: "schueler", header: "10. Schulausbildung / Studium", endpoint: `/api/shkperson/lbvstatus` },
  { key: "versorgung", header: "11. Zusätzliche Alters- und Hinterbliebenenversorgung", endpoint: `/api/shkperson/lbvstatus` },
  { key: "niedriglohn", header: "12. Für Beschäftigte im Niedriglohnbereich", endpoint: `/api/shkperson/lbvstatus` },

  // { key:'kurzfrist', header:'L. Für kurzfristig Beschäftigte', endpoint: `/api/shkperson/lbvstatus`,  },
];
buildSubSchemas(subpanels, schema);
_.map(subpanels, panel => _.assign(panel, { route: "/person/status", label: "LBV 2: Status" }));

const injects = _.flatMap(subpanels, s => injectsFromSchema(s.schema));
const selectInjects = createInjectsSelector(injects);

@store(...injects, "user", "flag_antragstellermodus")
export default class PersonLBVStatusTab extends Component {
  constructor() {
    super();
  }
  componentDidMount() {
    getModus(this.props);
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.flag_antragstellermodus !== this.props.flag_antragstellermodus) {
      await getModus(this.props);
    }
  }

  render() {
    return <SHKFormTab subpanels={subpanels} injects={selectInjects(this.props)} />;
  }
}
